/**
 * Wrapper for React.lazy that retries failed chunk loads
 * Helps with network issues and version mismatches during deployment
 */
export const lazyWithRetry = (
  importFn: () => Promise<any>,
  retriesLeft = 3,
  interval = 1000
): Promise<any> => {
  return new Promise((resolve, reject) => {
    importFn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 0) {
          // No retries left, reject with original error
          reject(error);
          return;
        }

        // Retry after interval
        setTimeout(() => {
          lazyWithRetry(importFn, retriesLeft - 1, interval)
            .then(resolve)
            .catch(reject);
        }, interval);
      });
  });
};
